module.exports = __webpack_public_path__ + "assets/7711ce5df38181c81594bfac9534ab77.mp3";